type YamahaProps = {
  className?: string;
};

export default function Yamaha({ className }: YamahaProps) {
  return (
    <svg
      width="116"
      height="32"
      viewBox="0 0 116 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>Yamaha</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.21228 1.96067L5.9706 1.91577L9.24756 12.8718L12.8836 1.96067L17.642 1.91577L11.6716 18.4845L11.6267 29.9344L6.37461 30.0242L6.4195 18.6192L1.21228 1.96067Z"
        fill="#121212"
        stroke="#121212"
        strokeWidth="1.23077"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4143 1.96191L15.9807 29.71L20.5138 29.8436L21.5937 23.5153H27.5616L28.5957 29.8894H33.5791L28.9085 1.96191H21.4143ZM24.6005 6.40466L26.9358 18.7558L22.4904 18.71L24.6005 6.40466Z"
        fill="#121212"
        stroke="#121212"
        strokeWidth="1.23077"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.2266 2.00574V29.755L40.5809 29.755V8.69608L44.4415 27.0609L48.4816 27.1058L52.1176 8.65118V29.7999L56.9208 29.7999V1.73633H49.1549L46.7757 15.2966L43.7681 2.00574L36.2266 2.00574Z"
        fill="#121212"
        stroke="#121212"
        strokeWidth="1.23077"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.5454 29.9346L84.214 30.0244L84.2588 17.3172L89.9598 17.3172V29.8448L94.808 29.8897V1.73631H89.8252V12.7821H84.3486V1.73631L79.5454 1.69141V29.9346Z"
        fill="#121212"
        stroke="#121212"
        strokeWidth="1.23077"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.9792 1.95044L59.5493 29.7023L64.0825 29.8359L65.1585 23.5039H71.1302L72.1605 29.8817H77.1439L72.4772 1.95044H64.9792ZM68.1654 6.397L70.5006 18.7443L66.0552 18.6985L68.1654 6.397Z"
        fill="#121212"
        stroke="#121212"
        strokeWidth="1.23077"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.485 2.00391L97.051 29.7558L101.584 29.8894L102.664 23.5573H108.632L109.666 29.9352H114.649L109.979 2.00391H102.485ZM105.671 6.45047L108.006 18.7978L103.561 18.7558L105.671 6.45047Z"
        fill="#121212"
        stroke="#121212"
        strokeWidth="1.23077"
      />
    </svg>
  );
}
